<template>
  <b-modal
    id="modal-atendimentos-dia"
    ref="modalAtendimentosDia"
    v-model="localEnabled"
    size="lg"
    centered
    scrollable
    hide-footer
    no-enforce-focus
    :busy="loading"
    @hidden="onHidden"
  >
    <template #modal-title>
      <strong>
        {{ dataDia }}
      </strong>
    </template>

    <div class="atendimentos-dia">
      <div class="info-table">
        <div class="info-table-item">
          <FonteSincronizadorC />
        </div>
        <div class="info-table-item">
          <b>{{ totalAtendimentos }}</b> atendimentos realizados
        </div>
        <div class="info-table-item">
          <button class="btn-pdf" @click="exportarDiaPdf">
            <i class="icofont-print"></i> PDF
          </button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-striped table-sm">
          <thead>
            <tr>
              <th>Estabelecimento</th>
              <th>Cidadão atendido</th>
              <th>Nascimento</th>
              <th>Data</th>
              <th>Hora</th>
              <th>Tipo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, i) in indexedItems" :key="i">
              <td>{{ row.no_unidade_saude }}</td>
              <td>{{ row.no_cidadao }}</td>
              <td>
                {{ row.dt_nascimento ? formatDate(row.dt_nascimento) : '' }}
              </td>
              <td>
                {{ row.dt_atendimento ? formatDate(row.dt_atendimento) : '' }}
              </td>
              <td>
                {{ row.dt_hour_atendimento }}
              </td>
              <td>{{ row.ds_tipo_atendimento }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </b-modal>
</template>

<script>
import utils from '@/mixins/utils.js'
import * as Functions from './functions.js'

export default {
  name: 'ModalAtendimentosDia',
  mixins: [utils],
  props: {
    enabled: { type: Boolean, default: false },
    profissional: { type: Object, default: () => ({}) },
    cadastros: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    dadosDoDia: { type: Object, default: () => null },
  },
  data() {
    return {}
  },
  computed: {
    localEnabled: {
      get() {
        return this.enabled
      },
      set(v) {
        this.$emit('update:enabled', v)
      },
    },
    totalAtendimentos() {
      return this.indexedItems.length
    },
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        index: index,
        ...item,
      }))
    },
    dataDia() {
      return `${this.formatDate(this.dadosDoDia?.dt_registro)} - ${
        this.dadosDoDia?.ds_dia_semana || ''
      }`
    },
  },
  methods: {
    /**
     * Manipula o fechamento do modal.
     */
    onHidden() {
      this.$emit('hidden')
    },

    /**
     * Gera o relatório em PDF.
     */
    exportarDiaPdf() {
      Functions.generatePdfDia(
        this.indexedItems,
        this.dataDia,
        this.totalAtendimentos
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.atendimentos-dia {
  .actions-buttons {
    display: flex;
    align-items: flex-end;
    gap: 10px;
  }
  .info-table {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 10px 0;
  }
}
</style>
